//environment-dependent configuration variables here
spanplusApp.provider('AppSettings', function () {

    var options = {};

    this.config = function(data) {
        var rssSpanHost = data.rssSpanHost;
        var spanPlusApiHost = data.spanPlusApiHost + '/';
        var identityManagementHost = data.identityManagementHost;
        var spanPlusS3Bucket = data.cdn_path;
        var showcaseWeb = data.showcaseUrl;
        var user = data.engineeringIMUser;
        var marketId = data.engineeringIMMarketId;
        var pass = data.engineeringIMPass;
        var showGWApiHost = data.showcaseGWApi;


        options.startSPANPlusSvcURL = spanPlusApiHost;
        options.socketServerUrl = spanPlusApiHost;
        options.showcaseGWApi = showGWApiHost + '/';

        options.startSPANVehicleProductSvcURL = rssSpanHost + '/rss.span.businessservices/restvehicleproductsvc.svc';
        options.startSPANVehicleRateSvcURL = rssSpanHost + '/rss.span.businessservices/restvehicleratesvc.svc';
        options.startSPANFormConfigSvcURL = rssSpanHost + '/rss.span.formconfiguration/restformconfiguration.svc';
        options.startSPANFormMappingSvcURL = rssSpanHost + '/rss.span.formconfiguration/restformmapping.svc';
        options.startSPANFormMergeSvcURL = rssSpanHost + '/rss.span.formconfiguration/restpdfformmerge.svc';
        options.startSPANVehicleDefURL = rssSpanHost + '/rss.span.businessservices/restvehicledefsvc.svc';
        options.startSPANDealerSettingsURL= rssSpanHost + '/rss.span.businessservices/restdealersettingssvc.svc';
        options.startSPANDealerPreferencesURL = rssSpanHost + '/rss.span.businessservices/restdealerpreferencessvc.svc';
        options.startSPANDealerPackSettingsURL = rssSpanHost + '/rss.span.businessservices/restdealerpacksettingssvc.svc';
        options.startSPANDealerProfileURL = rssSpanHost + '/rss.span.businessservices/restdealerprofilesvc.svc';

        options.startSPANRatePersistURL = rssSpanHost + '/rss.span.businessservices/RESTVehicleRatePersistSvc.svc';

        options.startSPANQuoteTokenSvcUrl = spanPlusApiHost + 'quotecontractintegrations';

        options.startIdentitySvcURL = identityManagementHost + '/';

        options.spanPlusS3Bucket = spanPlusS3Bucket;

        options.showcaseUrl = showcaseWeb;

        options.SESSION_IM_TOKEN = 'SESSION_IM_TOKEN';
        options.growlEnabled = !!data.showGrowl;

        options.zipCodeApiKey = data.zipCodeApiKey;

        options.showErrorsOnConsole = false;

        options.userTokenTimeMinutes = 1440;

        options.chatApplicationKey = data.icm_app;
    };

    this.$get = [function() {

        if(!options) {
            throw new Error('Configurations options missing');
        }
        return options;
    }];
});

spanplusApp.config(['growlProvider', function(growlProvider) {
    growlProvider.globalTimeToLive(10000);
    growlProvider.globalPosition('bottom-left');
    growlProvider.globalDisableCountDown(true);
}]);

